export { default as CallReportFilters } from '@/views/pages/reports/call/components/CallReportFilters.vue';
